import { useQueryClient } from '@tanstack/react-query'

type UseIsSwissGeolocation = () => boolean

const useIsSwissGeolocation: UseIsSwissGeolocation = () =>
  !!useQueryClient().getQueryData<boolean>(['isSwissGeolocation'])

export default useIsSwissGeolocation
